<style scoped lang="less">
.user {
    line-height: 34px;
}
.ammount-content {
    display: flex;
    align-items: flex-end;
    .amount {
        font-size: 20px;
        font-weight: bold;
    }
    .surplus {
        font-size: 14px;
        line-height: 14px;
    }
}
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-date-picker style="width: 250px" @change="refetchData" v-model="date" type="daterange"
                range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            <el-input class="margin-l" style="width: 200px;" placeholder="手机号、姓名" clearable @clear="refetchData"
                @input="refetchData" prefix-icon="el-icon-search" v-model="keyword"
                @keyup.native.enter="refetchData"></el-input>
            <el-button class="margin-l" type="success" @click.stop="addOrEdit('开通新会员')">开通新会员</el-button>
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="small" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column type="index" align="center" width="45"></el-table-column>
                <el-table-column label="日期" align="center" width="130">
                    <template slot-scope="scope" v-if="scope.row.date">
                        {{scope.row.date | fmt-time}}
                    </template>
                </el-table-column>
                <el-table-column label="用户" width="240">
                    <template slot-scope="scope" v-if="scope.row.user">
                        <div :style="selectedStyle(scope.$index)" class="user">
                            {{scope.row.user.phone}}&nbsp;&nbsp;{{scope.row.user.name}}</div>
                    </template>
                </el-table-column>

                <el-table-column label="金额" width="120">
                    <template slot-scope="scope">
                        <div class="ammount-content">
                            <div class="amount" :style="calcAmount(scope.row.amount)">
                                {{scope.row.amount > 0 ? `+${scope.row.amount}` : scope.row.amount}}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="remarks" width="140"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope" v-if="scope.$index == index">
                        <el-button size="small" type="primary" style="font-weight:bold"
                            @click.stop="addOrEdit('充值')">充值</el-button>
                        <el-button size="small" class="margin-l" style="font-weight:bold" type="danger"
                            @click.stop="addOrEdit('消费')">消费</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-daily ref="edit" @fetch-data="fetchData"></dialog-edit-daily>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditDaily from "../components/dialog/dialogEditDaily";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";
import { loginState } from "../util/login.js";
import dayjs from "dayjs";

export default {
    components: {
        DialogEditDaily,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            item: null,
            date: [],
            index: -1,
        };
    },
    created() { },
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() { },
    methods: {
        handleCurrentChange(val) {
            if (!val) return (this.item = val);
            this.item = val;
            this.data.forEach((it, index) => {
                if (it._id == val._id) {
                    this.index = index;
                }
            });
        },
        selectedStyle(index) {
            if (index == this.index) {
                return "font-weight:bold;font-size: 18px;color:#000";
            } else {
                return "font-weight:normal;font-size: 14px;";
            }
        },
        calcAmount(amount) {
            if (amount < 0) {
                return "color:#f56c6c";
            } else {
                return "color:#67c23a";
            }
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            this.index = -1;
            let cond = {
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
            };
            if (this.keyword) {
                cond.user = this.keyword;
            }
            if (this.date && this.date.length) {
                let [start, end] = this.date;
                cond = {
                    ...cond,
                    date: {
                        $gte: dayjs(start).startOf("day"),
                        $lte: dayjs(end).endOf("day"),
                    },
                };
            }
            let res = await HttpClient.post("/value/getAll", cond);
            this.data = res.result;
            this.table.submitTotal(res.count);
        },
        addOrEdit(type) {
            let cond = {
                type,
                date: new Date(),
                user: this.item && this.item.user && type != "开通新会员" ? this.item.user : null,
                store: loginState.admin.store ? loginState.admin.store : null,
            };
            this.edit.addOrEdit(cond);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("Value", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
